// Supabase client configuration
// En local : définir VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env.local
// En production : utilise les valeurs par défaut ci-dessous
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ijctzhqvmirvgpuldkiv.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqY3R6aHF2bWlydmdwdWxka2l2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkxNTQ0MTUsImV4cCI6MjA2NDczMDQxNX0.nbMcJmQhBOtfi9JXfJv8tEeB2v42IdUdCH23YDSDMr8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);

// Fonctions utilitaires pour la gestion des PIN
export type AppRole = 'employe' | 'contremaitre' | 'manager';

export async function setEmployeePin(profileId: string, pin: string) {
  return await supabase.rpc('set_employee_pin', { profile_id: profileId, new_pin: pin });
}

export async function verifyEmployeePin(identifier: string, pin: string) {
  return await supabase.rpc('verify_employee_pin', { p_identifier: identifier, p_pin: pin });
}

export async function verifyEmployeePinOnly(pin: string) {
  return await supabase.rpc('verify_employee_pin_only', { p_pin: pin });
}

export async function generateEmployeePin(profileId: string) {
  return await supabase.rpc('generate_employee_pin', { profile_id: profileId });
}

export async function getEmployeePin(profileId: string) {
  return await supabase.rpc('get_employee_pin', { profile_id: profileId });
}

export async function createPinRecovery(profileId: string) {
  return await supabase.rpc('create_pin_recovery', { profile_id: profileId });
}